import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MonthlyExpensesService } from 'app/modules/monthly-expenses/services/monthly-expenses.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ExpensesPeriod } from 'app/modules/monthly-expenses/entities/monthly-expenses-modal';
import { DateAdapter } from '@angular/material/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-expenses-date',
    templateUrl: './expenses-date.component.html',
    styleUrls: ['./expenses-date.component.scss'],
    standalone: false
})
export class ExpensesDateComponent implements OnInit {

  private selectedDate: moment.Moment;
  public date: UntypedFormControl;
  
  constructor(public monthlyExpensesService: MonthlyExpensesService,
              private sharedService: SharedService, 
              private dateAdapter: DateAdapter<any>) { }

  ngOnInit(): void {
    moment.locale('es');
    this.dateAdapter.setLocale('es');
    this.initDateValue();
    this.date = new UntypedFormControl();
  }

  initDateValue(): void {
    this.date = new UntypedFormControl();
    this.monthlyExpensesService.getInitialDates().subscribe(res => {
      if (res.code === 0) {
        this.selectedDate = moment().set({ year: res.result.year, month: (res.result.month - 1)});
        this.date.setValue(this.selectedDate.format('MMMM, YYYY'));
        this.refreshExpensesList();
      } else {
        this.sharedService.ShowSnackBar('No se pudo cargar la fecha inicial', 'Okay', 2000);
      }
    }, error => {
      this.sharedService.ShowSnackBar('No se pudo cargar la fecha inicial', 'Okay', 2000);
      console.error(error);
    });
  }

  refreshExpensesList(): void {
    const period = new ExpensesPeriod();
    period.year = this.selectedDate.year();
    period.month = this.selectedDate.month() + 1;
    this.monthlyExpensesService.updateExpensesList(period);
  }

  changeDate(navigationType: string): void {
    switch (navigationType) {
      case 'prev':
        this.selectedDate = moment(this.selectedDate.add(-1, 'months'));
        break;

      case 'next':
        this.selectedDate = moment(this.selectedDate.add(1, 'months'));
        break;
    
      default:
        break;
    }

    this.date.setValue(this.selectedDate.format('MMMM, YYYY'));
    this.refreshExpensesList();
  }

}
